<template>
    <modal-dialog :show.sync="show" :closable="false" :panel_ids="['confirm']" :current_panel_id.sync="current_panel_id">
        <template slot="panel-header">
            <span :class="header_class">
                <open-icon v-if="!!confirm.icon" :glyph="confirm.icon"></open-icon>
                {{ confirm.title }}
            </span>
        </template>
        <template slot="panel-body">
            <p class="text-center">{{ confirm.message }}</p>
        </template>
        <template slot="panel-footer">
            <button type="button" class="btn" @click.prevent="close(false)">
                {{ confirm.cancel }}
            </button>
            <button type="button" :class="button_class" class="btn" @click.prevent="close(true)">
                {{ confirm.ok }}
            </button>
        </template>
    </modal-dialog>
</template>

<script type="text/javascript">
import { mapState } from "vuex"

import { OpenIcon } from "../nibnut/components"
import { ModalDialog } from "../library"

export default {
    components: {
        ModalDialog,
        OpenIcon
    },
    methods: {
        close (confirmed) {
            if(confirmed) this.confirm.resolve()
            else this.confirm.reject()
        }
    },
    computed: {
        ...mapState({
            confirm: "confirmation"
        }),
        show: {
            get: function () {
                return !!this.confirm && !!this.confirm.title
            },
            set: function (show) {
                if(!show) this.close(false)
            }
        },
        header_class () {
            if(!this.confirm || !this.confirm.type) return false
            return { ["text-" + this.confirm.type]: true }
        },
        button_class () {
            if(!this.confirm || !this.confirm.type) return false
            return { ["btn-" + this.confirm.type]: true }
        }
    },
    data () {
        return {
            current_panel_id: "confirm"
        }
    }
}
</script>
